// Image imports
import vivianSilverPhoto from '../../../images/vivian_silver.jpeg';

export const vivianSilverMemorial = {
  id: 10,
  name: 'Vivian Silver',
  category: 'community-leaders',
  images: {
    portrait: vivianSilverPhoto
  },
  info: `

"Speak truth to power." - Vivian Silver's lifelong motto

![Vivian Silver](${vivianSilverPhoto})
*Vivian Silver, a tireless advocate for peace and women's rights*

## A Life Dedicated to Peace and Equality

Vivian Silver (1949-2023) was a Canadian-Israeli peace activist, feminist, and community leader whose life was tragically cut short during the Hamas attack on Kibbutz Be'eri on October 7, 2023.

## Early Years and Aliyah

Born in Winnipeg, Canada, Vivian was deeply influenced by the socialist Zionist Habonim youth movement. In 1974, she made aliyah, moving from a commune in Brooklyn to Kibbutz Gezer in Israel, bringing with her a passion for feminism and social justice.

## Pioneering Feminist Work

At Kibbutz Gezer, Vivian became a pioneer in studying and addressing gender bias in the kibbutz movement and Israeli society. Her efforts led to:

- Founding the United Kibbutz Movement's Department to Advance Gender Equality in 1981
- Serving on a Knesset subcommittee for the Advancement of Women in Work and the Economy
- Becoming one of only seven women serving as director generals of the 150 kibbutzim in Israel

## Peace Activism and Arab-Jewish Cooperation

In 1990, Vivian moved to Kibbutz Be'eri near the Gaza border, where she dedicated herself to peace activism and Arab-Jewish cooperation:

- Served as CEO of NISPED (Negev Institute for Peace and Development Strategies)
- Co-founded AJEEC (Arab-Jewish Center for Equality Empowerment and Cooperation) with Amal Elsana Alh'jooj in 2000
- Actively participated in Women Wage Peace, an interfaith grassroots organization

## A Legacy of Bridge-Building

Vivian's work was characterized by her ability to build relationships across divides, her persistence in the face of opposition, and her commitment to speaking truth to both power and peers. As her friend Shifra Bronznick noted:

> "Speaking those truths to peers—about war and peace, occupation or negotiation, sexism or equality—is hard and frightening. But Vivian believed that the only way to make change is to build trust and do the necessary work with our heads, hands, and hearts."

## Remembering Vivian

To honor Vivian's legacy, her family and friends are launching the Vivian Silver Impact Award in 2024. This award will annually recognize two women, Arab and Jewish, who demonstrate great promise in building Arab-Jewish partnerships in Israel and promoting peace between Israel and Palestine.

Vivian Silver's life serves as an inspiration for those working towards peace, equality, and understanding in Israel and beyond. Her tragic death is a reminder of the ongoing challenges in the region, but her legacy continues to inspire hope and action for a better future.

[Read more about Vivian Silver's life and work](https://jwa.org/weremember/silver-vivian)

[Learn about the impact of Vivian's activism](https://fathomjournal.org/in-memory-of-vivian-silver-1949-2023/)

`
};